module.exports = __webpack_public_path__ + "img/12.75181b16.png";